module.exports = __webpack_public_path__ + "img/top-zixun-code.d6b2234.png";